export enum PageSize {
  Size5 = 5,
  Size10 = 10,
  Size25 = 25,
  Size50 = 50,
  Size100 = 100,
  Size1000 = 1000,
}

export const PAGE_SIZE_OPTIONS: PageSize[] = [PageSize.Size5, PageSize.Size10, PageSize.Size25, PageSize.Size50, PageSize.Size100];

// Defaults
export const DEFAULT_PAGE_SIZE = PageSize.Size50;
export const DEFAULT_PAGE_INDEX = 0;

// Sorteringsriktning
export enum SortDirection {
  Asc = 'asc',
  Desc = 'desc',
}
export const DEFAULT_SORT_DIR = SortDirection.Desc;
